<template>
  <div>
    <Card :bordered="false" :padding="10" v-show="!onChild">
      <div slot="title">库存列表</div>
      <!-- 查询 -->
      <div class="serach">
        <Form ref="formValidate" :label-width="90" inline>
          <div>
            <FormItem label="仓库">
              <biz-select v-model="queryParams.storageId" textField="storageName" codeField="storageId" url="http://MID-OPERATE-LOGISTICS/messageService/queryService/queryManagerStorageInfo" :params="{}" />
              <!-- <dict-select v-model="queryParams.storageId" namespace="bizObjects" id="warehouse" :exclusion="[]" /> -->
            </FormItem>
            <FormItem label="仓库类型">
              <dict-select v-model="queryParams.storageType" namespace="ENUM_CORE-STORAGE" id="storageBaseInfo.StorageType" :exclusion="[]" />
            </FormItem>
            <!-- <FormItem label="二级分类">
                         <dict-select v-model="queryParams.targetSort" namespace="target" id="sort" :exclusion="[]"/>
                    </FormItem> -->
            <FormItem label="标的物分类">
              <targetTypeCascader v-model="queryParams.targetType" />
            </FormItem>
            <FormItem label="标的物" v-if="queryParams.targetType">
              <biz-select v-model="queryParams.targetCode" codeField="code" url="http://CORE-TARGET/messageService/leaseTargetService/queryAllTargetCodesUnionByType" :params="{targetType:queryParams.targetType}" />
            </FormItem>
            <FormItem label="品质类型">
              <dict-select v-model="queryParams.qualityType" namespace="ENUM_CORE-STORAGE" id="operateService.QualityType" :exclusion="[]" />
            </FormItem>
            <FormItem label="用途类型">
              <dict-select v-model="queryParams.useType" namespace="ENUM_CORE-STORAGE" id="operateService.UseType" :exclusion="[]" />
            </FormItem>

            <Button type="primary" style="margin-left:20px" @click="getQuery">查询</Button>
            <!-- <Button type="success" style="margin-left:20px" @click="adjustAddView(false)">盘盈</Button> -->
          </div>
        </Form>
      </div>
      <!-- 列表 -->
      <div class="table">
        <data-grid ref="dg" :columns="cols" :queryParams="queryParams" paramsName="param" :pageSize="20" :queryUrl="queryUrl" exportId="queryInventoryList" exportFileName="库存列表">
          <template #default="{columns, data}">
            <Table :columns="columns" :data="data" border stripe size="small" highlight-row>
              <template slot-scope="{ row }" slot="storageId">
                <a @click="showFlow(row.storageId)">{{row.storageName}}</a>
                <!-- <a @click="showFlow(row.storageId)">{{$options.filters['queryDict']('bizObjects','warehouse',row.storageId)}}</a> -->
              </template>
              <template slot-scope="{ row }" slot="action">
                <Button v-if="row.useType === 'RENT'" :disabled="row.targetCode!='-'||row.num<=0||row.type=='OUTER'" size="small" type="primary" @click="sort(row)">分拣</Button>
                <!-- <Button :disabled="row.num<=0||row.type=='OUTER'" size="small" type="warning" @click="adjustMinusView(row)" style="margin:10px">盘损</Button>
                <Button :disabled="row.type=='OUTER'" size="small" type="success" @click="adjustAddView(row)">盘盈</Button>
                <Button v-if="row.qualityType=='DIRTY'" size="small" type="info" @click="clean(row)" style="margin:10px">清洗</Button>
                <Button v-if="row.qualityType=='DESTROY'" size="small" type="info" @click="repair(row)" style="margin:10px">维修</Button> -->
              </template>
            </Table>
          </template>
        </data-grid>
      </div>
    </Card>
    <Modal v-model="viewFlag" :title="viewTile">
      <Form ref="adjust" :label-width="100" inline>
        <FormItem label="仓库">
          <plt-biz-select v-model="currentRow.warehouseId" textField="storageName" codeField="storageId" url="http://MID-OPERATE-LOGISTICS/messageService/queryService/queryManagerStorageInfo" :params="{}" />
          <!-- <dict-select v-model="currentRow.warehouseId" namespace="bizObjects" id="ValidWarehouse" :exclusion="[]" :disabled="!viewEdit" /> -->
        </FormItem>
        <FormItem label="标的物小类">
          <dict-select v-model="currentRow.targetType" namespace="target" id="type" :exclusion="[]" :disabled="!viewEdit" />
        </FormItem>
        <FormItem label="标的物" v-if="currentRow.targetType">
          <plt-biz-select v-model="currentRow.targetCode" textField="code" codeField="text" url="http://CORE-TARGET/messageService/leaseTargetService/queryAllTargetCodesUnionByType" :params="{targetType:currentRow.targetType}" />

          <!-- <dict-select v-model="currentRow.targetCode" namespace="target" id="code" :exclusion="[]" :disabled="!viewEdit" /> -->
        </FormItem>
        <FormItem label="品质类型">
          <dict-select v-model="currentRow.qualityType" namespace="ENUM_CORE-STORAGE" id="operateService.QualityType" :exclusion="[]" :disabled="!viewEdit" />
        </FormItem>
        <FormItem label="用途类型">
          <dict-select v-model="currentRow.useType" namespace="ENUM_CORE-STORAGE" id="operateService.UseType" :exclusion="[]" :disabled="!viewEdit" />
        </FormItem>
        <FormItem label="调整数量">
          <InputNumber v-model="currentRow.num" :min="1" style="width:200px" />
        </FormItem>
        <FormItem label="调整备注">
          <Input v-model="currentRow.remark" type="textarea" style="width:200px" />
        </FormItem>
        <br>
        <FormItem label="是否资产处置" v-if="viewTile=='盘损'">
          <i-switch v-model="currentRow.isAssetDeduct" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="commitAdjust">提交</Button>
      </div>
    </Modal>

    <Modal v-model="actionViewFlag" :title="viewTile" width="70%">
      <Form ref="adjust" :label-width="100" inline>
        <FormItem label="调整数量">
          <InputNumber v-model="currentRow.num" :min="1" style="width:200px" />
        </FormItem>
        <FormItem label="维修后品质" v-if="actionType == 'repair'">
          <dict-select v-model="currentRow.targetQualityType" namespace="ENUM_CORE-STORAGE" id="operateService.QualityType" :exclusion="['DESTROY','UNKNOWN']" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="changeQualityType">提交</Button>
      </div>
    </Modal>

    <flowModal ref="flowModal" :params="flowQueryParams" />

    <sort v-if="onChild" @on-finish="sortFinish" :paramData="currentRow"></sort>
  </div>
</template>
<script>
import dataGrid from "@/components/datagrid.vue";
import dictSelect from "@/components/select/dict-select.vue";
import sort from "@/views/storage/task/sort-pallet";
import targetTypeCascader from "@/components/select/targetType-cascader.vue";
import targetCascader from "@/components/select/target-cascader.vue";
import flowModal from "@/views/storage/task/storage-inventory-flow-modal.vue";
import bizSelect from "@/components/select/biz-select.vue";

export default {
  components: {
    dataGrid,
    dictSelect,
    sort,
    targetTypeCascader,
    targetCascader,
    flowModal,
    bizSelect
  },
  data() {
    return {
      queryUrl:
        "http://CORE-STORAGE/messageService/operateService/queryStorageManagerInventoryList",
      cols: [
        { title: "仓库", slot: "storageId" },
        // {title: '仓库', key: 'storageId', dict: ['bizObjects', 'warehouse',true]  },
        {
          title: "标的物小类",
          key: "targetType",
          dict: ["target", "type", true],
        },
        {
          title: "标的物编码",
          key: "targetCode",
          dict: ["target", "targetCodeUnion", true],
        },
        {
          title: "用途类型",
          key: "useType",
          dict: ["ENUM_CORE-STORAGE", "operateService.UseType"],
        },
        {
          title: "品质类型",
          key: "qualityType",
          dict: ["ENUM_CORE-STORAGE", "operateService.QualityType"],
        },
        { title: "数量", key: "num" },
        { title: "办理", slot: "action" },
      ],
      queryParams: {
        storageType: "",
        storageId: "",
        targetType: "",
        useType: "",
        qualityType: "",
        targetCode: "",
      },
      onChild: false,
      currentRow: {
        warehouseId: "",
        targetType: "",
        useType: "",
      },
      viewFlag: false,
      viewTile: "",
      viewUrl: "",
      viewEdit: false,
      actionViewFlag: false,
      actionType: "",
      flowQueryParams: {},
    };
  },
  watch: {
    "queryParams.targetType": function (newVal) {
      if (!newVal) this.queryParams.targetCode = "";
    },
  },
  // async mounted(){
  //     await this.dict.initDict([{ id: 'warehouse', namespace: 'bizObjects',force:true }]); // 初始化字典
  // },
  methods: {
    showFlow(storageId) {
      this.flowQueryParams.storageId = storageId;
      this.$refs["flowModal"].openModal();
    },
    adjustMinusView(row) {
      this.copyRow(row);
      this.viewTile = "盘损";
      this.viewUrl =
        "http://MID-OPERATE-STORE/messageService/operateService/adjustMinus";
      this.viewFlag = true;
      this.viewEdit = false;
    },
    adjustAddView(row) {
      this.copyRow(row);
      this.viewTile = "盘盈";
      this.viewUrl =
        "http://MID-OPERATE-STORE/messageService/operateService/adjustAdd";
      this.viewFlag = true;
      if (row) {
        this.viewEdit = false;
      } else {
        this.viewEdit = true;
      }
    },
    commitAdjust() {
      let params = {
        url: this.viewUrl,
        body: this.currentRow,
      };
      this.invoke(params).then((rs) => {
        if (rs) {
          this.getQuery();
          this.currentRow = {};
          this.viewFlag = false;
          this.$Message.info("提交成功!");
        }
      });
    },
    getQuery() {
      this.$refs["dg"].loadFirstPage();
    },
    sort(row) {
      this.copyRow(row);
      this.onChild = true;
    },
    copyRow(row) {
      this.currentRow = {};
      if (row) {
        this.currentRow.warehouseId = row.storageId;
        this.currentRow.targetType = row.targetType;
        this.currentRow.useType = row.useType;
        this.currentRow.qualityType = row.qualityType;
        this.currentRow.targetCode =
          row.targetCode == "-" ? "" : row.targetCode;
        this.currentRow.isAssetDeduct = true;
      }
      this.currentRow.num = "";
    },
    sortFinish() {
      this.$refs["dg"].queryData();
      this.onChild = false;
    },
    clean(row) {
      this.actionType = "clean";
      this.copyRow(row);
      this.currentRow.targetQualityType = "GOOD";
      this.viewTile = "清洗";
      this.actionViewFlag = true;
    },
    repair(row) {
      this.actionType = "repair";
      this.copyRow(row);
      this.viewTile = "维修";
      this.actionViewFlag = true;
    },
    changeQualityType() {
      if (!this.currentRow.num || !this.currentRow.targetQualityType) {
        this.$Message.info("请补全信息!");
        return;
      }
      let params = {
        url: "http://MID-OPERATE-STORE/messageService/operateService/changeQualityType",
        body: this.currentRow,
      };
      this.invoke(params).then((rs) => {
        if (rs) {
          this.getQuery();
          this.currentRow = {};
          this.actionViewFlag = false;
        }
      });
    },
  },
};
</script>